import { Checkbox, NumberInput, Text, Textarea } from "@mantine/core"
import {
  OrchestraActivityDto,
  AddCastRequest,
  CastFormFields,
  EditCastRequest,
} from "@/@client/Theasoft_ApiServer_Orchestra"
import { UseFormReturnType } from "@mantine/form"
import { getFormattedTimePeriod } from "@/utils/get-formatted-time"
import { SelectEntity } from "@components/entity-select"
import { useTranslation } from "react-i18next"
import { getFormattedDate } from "@/utils/get-formatted-date"
import { ActivityTypeText } from "@/routes/app/art/activities/-components/activity-type-text"
import { backAndForeColorToHex } from "@/utils/color-to-rgba"
import { PathProxy } from "@/utils/forms-proxy"
import { useQueryGet } from "@/typed-client/hooks/use-query-get"

export function RenderActivity({
  activity,
}: {
  activity: OrchestraActivityDto
}) {
  const hexColors = backAndForeColorToHex(activity.activityType.color)
  return (
    <>
      <Text>
        {`${getFormattedDate(activity.date)} ${getFormattedTimePeriod(activity.timePeriod)}${activity.stage ? " (" + activity.stage + ")" : ""}`}
      </Text>
      <Text>
        <ActivityTypeText
          name={activity.activityType.name}
          foreColor={hexColors.foreColor}
          backColor={hexColors.backColor}
          span
        />{" "}
        <Text
          span
          fw={activity.activityType.isPerformance ? "bold" : undefined}
          tt={activity.activityType.isPerformance ? "uppercase" : undefined}
        >
          {activity.title}
        </Text>
      </Text>
    </>
  )
}

export function SharedControls({
  f,
  activityId,
  contractId,
  workareaId,
  _,
}: {
  f: UseFormReturnType<AddCastRequest | EditCastRequest>
  _: PathProxy<AddCastRequest | EditCastRequest, CastFormFields>
  activityId: number
  contractId: number
  workareaId: number
}) {
  const { t } = useTranslation("app_server")
  const { data: module } = useQueryGet(
    "/api/WorkArea/GetWorkareaModule",
    {
      workareaId,
    },
    { gcTime: 4 * 60_000 }
  )
  return (
    <>
      <SelectEntity
        url="/api/Orchestra/GetCastableRoles"
        label={module === "theaOrchester" ? t("Instrument") : t("Role")}
        // the required prop here does not prevent submitting, just shows an indicator
        required
        toRequest={() => ({
          activityId: activityId,
          contractId: contractId,
          workareaId: workareaId,
          filterCastedRoles: false,
        })}
        getId={(v) => v.id}
        getLabel={(v) => v.name}
        {...f.getInputProps(_.roleId._PATH_)}
      />
      <Checkbox
        label={t("OverrideServiceCountForCast")}
        checked={f.values.properties.creditableValue !== null}
        onChange={(v) => {
          f.setFieldValue(_.creditableValue._PATH_, v.target.checked ? 1 : null)
        }}
      />
      {f.values.properties.creditableValue !== null ? (
        <NumberInput
          label={t("ServiceCount")}
          decimalScale={2}
          {...f.getInputProps(_.creditableValue._PATH_)}
        />
      ) : null}
      <Checkbox
        label={t("Canceled")}
        {...f.getInputProps(_.isCanceled._PATH_, { type: "checkbox" })}
      />
      <Checkbox
        label={t("Cover")}
        {...f.getInputProps(_.isCover._PATH_, { type: "checkbox" })}
      />
      <Checkbox
        label={t("Replacement")}
        checked={f.values.properties.isReplacement}
        {...f.getInputProps(_.isReplacement._PATH_, { type: "checkbox" })}
      />
      {/* TODO: disabled for now */}
      {/* <Checkbox */}
      {/*   label={t("Secret")} */}
      {/*   checked={f.values.isSecret} */}
      {/*   {...f.getInputProps("isSecret", { type: "checkbox" })} */}
      {/* /> */}
      <Textarea
        label={t("Remark")}
        placeholder={t("Remark")}
        {...f.getInputProps(_.note._PATH_)}
      />
    </>
  )
}
